import { useMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  symbol: string;
};

export default function QuoteVolume({ symbol }: Props) {
  const { quoteVolume, priceDecimals, sizeDecimals } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      quoteVolume: state.marketData.quoteVolume ?? 0n,
      priceDecimals: state.marketSpec.priceDecimals,
      sizeDecimals: state.marketSpec.sizeDecimals,
    })),
  );
  return formatBigInt(quoteVolume, priceDecimals + sizeDecimals, {
    digits: 2,
    style: 'currency',
    compact: true,
  });
}

export const quoteVolumeAccessorFn = (symbol: string) => {
  const {
    marketData: { quoteVolume = 0n },
    marketSpec: { priceDecimals, sizeDecimals },
  } = useMarketStore(symbol).getState();
  return bigIntToNum(quoteVolume, priceDecimals + sizeDecimals);
};
